import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckboxChipButton } from '@cian/ui-kit';

import { getChipDataTestId } from './utils';
import { promosApplyChipsRequestAction } from '../../actions/chips';
import { Chip } from '../../components/Chip';
import { ChipsLayout } from '../../components/ChipsLayout';
import { DialogChipButton } from '../../components/DialogChipButton';
import { selectChips } from '../../selectors/chips';
import { selectIsCompilation } from '../../selectors/compilation';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TThunkDispatch } from '../../types/redux/thunk';

export const ChipsContainer: React.FC = () => {
  const dispatch: TThunkDispatch = useDispatch();
  const chips = useSelector(selectChips);
  const isCompilation = useSelector(selectIsCompilation);

  const activeRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({
        block: 'nearest',
        inline: 'center',
      });
    }
  }, []);

  const handleChange = React.useCallback(
    (jsonQuery: IJsonQuery, isActive: boolean) => {
      dispatch(promosApplyChipsRequestAction(jsonQuery, isActive));
    },
    [dispatch],
  );

  if (isCompilation) {
    return null;
  }

  return (
    <ChipsLayout>
      {chips.map(item => {
        const ref = item.isActive ? activeRef : null;

        if ('dialog' in item) {
          return (
            <Chip key={item.name} ref={ref}>
              <DialogChipButton
                label={item.name}
                onChange={handleChange}
                checked={item.isActive}
                size="M"
                data-testid={getChipDataTestId(item.isActive)}
                dialogFilters={item.dialog.filters}
                dialogTitle={item.dialog.title}
              />
            </Chip>
          );
        }

        return (
          <Chip key={item.name} ref={ref}>
            <CheckboxChipButton
              label={item.name}
              onChange={() => handleChange(item.jsonQuery, item.isActive)}
              checked={item.isActive}
              size="M"
              data-testid={getChipDataTestId(item.isActive)}
            />
          </Chip>
        );
      })}
    </ChipsLayout>
  );
};
